import React from 'react';

interface PathData {
  d: string;
  strokeLinecap?: 'round' | 'butt' | 'square';
  strokeLinejoin?: 'round' | 'miter' | 'bevel';
  strokeWidth?: string;
}

interface BaseIconProps {
  title: string;
  paths: PathData | PathData[];
}

export const BaseIcon: React.FC<BaseIconProps> = ({ title, paths }) => {
  const pathsArray = Array.isArray(paths) ? paths : [paths];

  return (
    <div title={title}>
      <svg
        className="w-6 h-6 text-base-content"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        {pathsArray.map((pathData, index) => (
          <path
            key={index}
            stroke="currentColor"
            strokeLinecap={pathData.strokeLinecap || 'round'}
            strokeLinejoin={pathData.strokeLinejoin || 'round'}
            strokeWidth={pathData.strokeWidth || '2'}
            d={pathData.d}
          />
        ))}
      </svg>
    </div>
  );
};
